import { cn } from "@/lib/utils"

interface AmbientBackgroundProps {
  variant?: "default" | "subtle" | "success" | "error"
  className?: string
  blob1Color?: string
  blob2Color?: string
}

export function AmbientBackground({ 
  variant = "default", 
  className,
  blob1Color,
  blob2Color
}: AmbientBackgroundProps) {
  return (
    <div className={cn("fixed inset-0 overflow-hidden pointer-events-none z-0", className)}>
      {variant === "default" && (
        <>
          <div className={cn("absolute -top-40 -right-40 w-96 h-96 rounded-full blur-3xl transition-colors duration-500", blob1Color || "bg-primary/10")} />
          <div className={cn("absolute top-1/2 -left-40 w-80 h-80 rounded-full blur-3xl delay-700 transition-colors duration-500", blob2Color || "bg-purple-500/10")} />
        </>
      )}

      {variant === "subtle" && (
        <>
          <div className="absolute -top-40 -right-40 w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
          <div className="absolute top-1/2 -left-40 w-80 h-80 bg-purple-500/5 rounded-full blur-3xl" />
        </>
      )}

      {variant === "success" && (
        <>
          <div className="absolute -top-40 -right-40 w-96 h-96 bg-green-500/10 rounded-full blur-3xl" />
          <div className="absolute top-1/2 -left-40 w-80 h-80 bg-emerald-400/10 rounded-full blur-3xl" />
        </>
      )}

      {variant === "error" && (
        <>
          <div className="absolute -top-40 -right-40 w-96 h-96 bg-red-500/10 rounded-full blur-3xl" />
          <div className="absolute top-1/2 -left-40 w-80 h-80 bg-red-400/10 rounded-full blur-3xl" />
        </>
      )}
    </div>
  )
}
